
import React from 'react';
import './videocontent.css';

const VideoContent = ({ video, course }) => {

    if (!video || !course) {
        return <div>Cargando...</div>; 
    }

    return (
        <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4">{course.title}</h1>
                    <h2 className="h5 text-muted">{video.title}</h2>
                </div>
            </div>
            <div>
                <p>{video.description || "No hay descripción para este video."}</p>
            </div>
            {/* Progress information can be added here later */}
        </div>
    );
}

export default VideoContent;